"use client";

import { PropertyDataV2 } from "commonModule/services/common";
import PropertyItemWrapper from "components/pages/vacation-rentals/PropertyItemWrapper";
import PropertyImageSlider from "components/slider/PropertyImageSlider";
import TravelAgentPropertyCardBody from "components/travel-agent/TravelAgentPropertyCardBody";
import { useAppSelector } from "stores/hooks";
import { selectSearchQuery } from "stores/search/searchSlice";
import { customSlugify } from "utils/url";
type Props = {
  property: PropertyDataV2;
  propertyIndex: number;
};
const TravelAgentSearchCard = ({
  property,
  propertyIndex
}: Props) => {
  const searchQuery = useAppSelector(selectSearchQuery);
  const query = new URLSearchParams();
  if (searchQuery?.startDate) query.set("check_in", searchQuery.startDate);
  if (searchQuery?.endDate) query.set("check_out", searchQuery.endDate);
  query.set("adultsCount", String(searchQuery?.adultCount ?? (property.noOfGuest > 1 ? 2 : 1)));
  if (searchQuery?.childrenCount) query.set("childrenCount", String(searchQuery.childrenCount));
  query.set("allInPriceToggle", "true");
  const propertyUrl = `/detail/${customSlugify(property.propertyName) || "Whimstay"}/${property._id}?${query.toString()}`;
  return <PropertyItemWrapper property_id={property._id} data-sentry-element="PropertyItemWrapper" data-sentry-component="TravelAgentSearchCard" data-sentry-source-file="TravelAgentSearchCard.tsx">
      <article className='group flex w-full min-w-0 animate-fadeInOut flex-col pb-2'>
        <div className='relative h-full w-full overflow-hidden rounded-lg'>
          <PropertyImageSlider propertyId={property._id} images={property.images.slice(0, 5)} loading={propertyIndex < 1 ? "eager" : "lazy"} propertyUrl={propertyUrl} defaultAlt={`${property.propertyName} in ${property.city}, ${property.state}`} data-sentry-element="PropertyImageSlider" data-sentry-source-file="TravelAgentSearchCard.tsx" />
        </div>

        <div className='mt-[15px] lg:mt-2.5'>
          <TravelAgentPropertyCardBody property={property} propertyUrl={propertyUrl} data-sentry-element="TravelAgentPropertyCardBody" data-sentry-source-file="TravelAgentSearchCard.tsx" />
        </div>
      </article>
    </PropertyItemWrapper>;
};
export default TravelAgentSearchCard;